import React from "react";

const BedSvg = () => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4998 3.49701C17.4998 2.94638 17.0534 2.5 16.5028 2.5H3.49682C2.94618 2.5 2.4998 2.94638 2.4998 3.49701V7.93001C2.02718 8.00821 1.66675 8.41882 1.66675 8.91361V14.7519C1.66675 14.7587 1.66685 14.7654 1.66705 14.7721C1.66685 14.7786 1.66675 14.7851 1.66675 14.7916V16.8749C1.66675 17.2201 1.94657 17.4999 2.29175 17.4999C2.63693 17.4999 2.91675 17.2201 2.91675 16.8749V15.4166H17.0831V16.8749C17.0831 17.2201 17.363 17.4999 17.7081 17.4999C18.0533 17.4999 18.3331 17.2201 18.3331 16.8749V14.7916C18.3331 14.7866 18.3331 14.7817 18.333 14.7767C18.3333 14.7685 18.3334 14.7602 18.3334 14.7519V8.91361C18.3334 8.41863 17.9727 8.00789 17.4998 7.92992V3.49701ZM4.58314 7.9166H3.75008V3.74993H16.2501V7.9166H15.4166V5.66471C15.4166 5.29762 15.119 5.00003 14.7519 5.00003H11.0813C10.7142 5.00003 10.4166 5.29762 10.4166 5.66471V7.9166H9.58314V5.66471C9.58314 5.29762 9.28555 5.00003 8.91846 5.00003H5.24781C4.88072 5.00003 4.58314 5.29762 4.58314 5.66471V7.9166ZM11.0813 9.1667L11.0745 9.16667H8.92529L8.91846 9.1667H5.24781L5.24099 9.16667H3.16448L3.15074 9.16653H2.91703V11.4583H17.0837V9.16653H16.8489L16.8351 9.16667H14.7588L14.7519 9.1667H11.0813ZM17.0837 12.7083H2.91703V14.1665H17.0837V12.7083ZM14.1669 6.24996V7.9166H11.6669V6.24996H14.1669ZM8.33341 7.9166H5.83342V6.24996H8.33341V7.9166Z"
          fill="#118BF4"
        ></path>
      </svg>
    </span>
  );
};

export default BedSvg;
